import './FleetHow.scss';

import React from 'react';
import cn from 'classnames';
import Button from '../../ui/Button/Button';
import { Image, Link, RichText } from '@sitecore-jss/sitecore-jss-react';

export default function FlowHow({ fields }) {
  return (
    <div className={'container fleet-how'}>
      <div className={'wrapper'} data-aos="fade-up">
        <div className={'content'}>
          <h2 className={'content_title'}>
            <RichText field={fields?.titleRichText} />
          </h2>
          <p className={'content_text'}>{fields?.desc?.value}</p>
          <div className={'content_buttonContainer'}>
            <a href={fields?.buttonUrl.value.href}>
              <Button className={'content_buttonContainer_button'} isShowTooltip={false}>
                {fields?.buttonText?.value}
              </Button>
            </a>
          </div>
        </div>
        <div className={cn('image', 'imageDesktop')}>
          <Image alt="img" field={fields?.image} />
        </div>
      </div>
    </div>
  );
}
